import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { unallocatedPaymentActions } from "../slices/unallocatedPayment";
import { getErrorMessage } from "../../utils/errorUtils";
import { UnallocatedPaymentResponseDto } from "../../shared/dtos/unallocatedPayment/UnallocatedPaymentResponseDto";
import { DateRangePaginationQueryDto } from "../../shared/dtos/common/DateRangePaginationQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getUnallocatedPayments =
  (params?: DateRangePaginationQueryDto) => async (dispatch: AppDispatch) => {
    dispatch(unallocatedPaymentActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<UnallocatedPaymentResponseDto>>
      >("/unallocated-payments", {
        headers: { requiresAuth: true },
        params,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(unallocatedPaymentActions.setItems(data.data.content));
        dispatch(unallocatedPaymentActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(unallocatedPaymentActions.setError(getErrorMessage(error)));
    }
  };
